<template>
  <v-container>
    <v-row>
      <v-alert v-if="estado === 0" type="error" outlined prominent class="my-4">
        <div>
          <div class="text-h6 font-weight-medium mb-2">
            Lamentamos tu partida
          </div>
          <div class="text-body-1 grey--text text--darken-1">
            Actualmente <strong>no puedes generar</strong> pases médicos porque tu membresía ha sido cancelada.<br>
            Si quieres reactivar tu acceso, contacta a tu agente de confianza y aprovecha un <strong>descuento
              especial</strong>.
          </div>
        </div>
      </v-alert>
      <v-alert v-if="estado === 2" type="warning" outlined prominent class="my-4">
        <div>
          <div class="text-h6 font-weight-medium mb-2">
            Tienes recibos de pago pendientes
          </div>
          <div class="text-body-1 grey--text text--darken-1">
            Actualmente <strong>no puedes generar</strong> pases médicos porque existe un <strong>retraso en tus
              pagos</strong>.<br>
            Por favor, visita la sección
            <router-link to="/user/recibos" class="font-weight-medium">Recibos</router-link>,
            descarga tu comprobante y efectúa tu pago para reactivar tus pases sin interrupciones.
          </div>
        </div>
      </v-alert>
      <v-col cols="12" md="12" lg="12">
        <h2 class="header-title-int">
          Listado de mis pases médicos.
        </h2>
        <p v-if="estado === 1" class="header-subtitle grey--text">
          ¡Tienes pases médicos disponibles! Utiliza tus pases para cuidar de ti y <strong>familia</strong> y tu salud.
          <v-chip class="ma-2" :color="numerocitas > 0 ? 'green darken-3' : 'red darken-3'" outlined small>
            <v-avatar left>
              <v-icon>
                {{ numerocitas > 0 ? 'mdi-checkbox-marked-circle' : 'mdi-alert-circle' }}
              </v-icon>
            </v-avatar>
            Pases disponibles: {{ numerocitas }}
          </v-chip>
        <v-sheet v-if="numerocitas === 0"
          class="pa-4 mt-4 rounded-lg elevation-2 d-flex align-center"
          color="blue lighten-5"
          style="border-left: 4px solid #1976D2;"
        >
          <div class="text-body-2">
            <span class="font-weight-medium">¡Aprovecha tu membresía!</span><br>
            Obtén <strong>pases médicos adicionales</strong> a un precio preferencial.<br>
            Contacta a tu agente o comunícate con <strong>MediCover</strong>.
          </div>
        </v-sheet>
        </p>
      </v-col>
    </v-row>
    <v-row v-show="this.numerocitas > 0 && this.estado === 1">
      <v-col cols="12">
        <div class="text-h6 font-weight-medium mb-2">
          Generar nuevo pase médico
        </div>
        <div class="text-body-1 grey--text text--darken-1">
          Selecciona la <strong>especialidad médica</strong>, el <b>médico</b> de tu preferencia 
          y el <b>paciente</b> que asistirá a la consulta.<br>
          Recuerda presentar tu pase <strong>físico o digital</strong> al momento de tu cita.
        </div>
      </v-col>
      <v-col cols="12" xs="6" sm="6" md="3" lg="3" xl="3">
        <select-especialidades-component @value-changed="updateEsp"></select-especialidades-component>
      </v-col>
      <v-col cols="12" xs="6" sm="6" md="3" lg="3" xl="3">
        <medicos-component v-show="especialidad" @value-changed="updateMed"
          :especialidadValue="especialidad"></medicos-component>
      </v-col>
      <v-col cols="12" xs="12" sm="6" md="3" lg="3" xl="3">
        <beneficiados-component v-show="medico" @value-changed="updateBen"
          :membresia="this.getIdTarjeta"></beneficiados-component>
      </v-col>
      <v-col cols="12" xs="12" sm="6" md="3" lg="3" xl="3">
        <v-btn v-show="medico" color="azulfuerte" @click="crearCita" dark block>
          <v-icon>mdi-plus</v-icon> GENERAR PASE </v-btn>
      </v-col>
    </v-row>

        <h3 class="mb-1 font-weight-medium">Mis pases médicos</h3>

    <table-read-citas-medicas :reloadTrigger="this.reloadTrigger" :resaltarId="lastCreatedId"
      :Membresia="this.getIdTarjeta"></table-read-citas-medicas>

  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import SelectEspecialidadesComponent from "@/components/selectEspecialidades.vue";
import MedicosComponent from "@/components/comboboxMedicosComponent.vue";
import BeneficiadosComponent from "@/components/selectBeneficiadosMembresia.vue";
import TableReadCitasMedicas from '@/components/opt/TableReadCitasMedicas.vue'

export default {
  name: "CitasCliente",
  created() {
    this.getNumCitas()
  },
  components: {
    SelectEspecialidadesComponent,
    MedicosComponent,
    TableReadCitasMedicas,
    BeneficiadosComponent
  },
  data: () => ({
    reloadTrigger: 0,
    lastCreatedId: null,
    numerocitas: 0,
    estado: null,
    nuevacita: null,
    especialidad: '',
    medico: '',
    beneficiado: '',
    valid: false,
    isModal: false,
    list: [],
    search: "",
    headers: [
      //{ text: "Id", value: "Id", sortable: false },
      { text: "Folio", value: "Folio", sortable: false },
      { text: "Parentesco", value: "Parentesco", sortable: false },
      { text: "Beneficiado", value: "Beneficiado", sortable: false },
      { text: "Especialidad", value: "Especialidad", sortable: true },
      { text: "Medico", value: "Medico", sortable: true },
      { text: "Estatus", value: "FecCierre", sortable: true },
      { text: "Creada", value: "created_at", sortable: true },
      { text: "Opciones", value: "ops", sortable: false },
    ],
  }),
  computed: {
    ...mapGetters(["getIdTarjetaTxt", "getIdTarjeta"]),
  },
  methods: {
    updateEsp(esp) {
      this.especialidad = esp
    },
    updateMed(med) {
      this.medico = med.IdMedico
    },
    updateBen(ben) {
      this.beneficiado = ben.Id
    },
    GenerarPase() {
      this.isModal = true
    },
    crearCita() {

      if (this.getIdTarjeta && this.especialidad && this.medico && this.beneficiado) {
        this.$http.post('membresia/citamedica', {
          idMem: this.getIdTarjeta,
          idEsp: this.especialidad,
          idMed: this.medico,
          idBen: this.beneficiado
        })
          .then(response => {

            if (response.status === 200) {
              this.nuevacita = response.data;
              this.marcarNuevo(response.data)

              this.getNumCitas()


              this.$swal({
                position: 'top-end',
                title: 'Correcto',
                text: 'Su pase médico se genero correctamente',
                icon: 'success',
                confirmButtonText: 'Cerrar',
                showCloseButton: false,
                showConfirmButton: false,
                timer: 1500,
                backdrop: false
              })
            } else {
              this.$swal({
                title: 'Infomación',
                text: 'No tienes pases sificientes puedes hacer una recarga de 5 a un costo especial contacta a tu agente.',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
                backdrop: false
              });
            }
          })
          .catch(() => {
          })
          .finally(() => {
            this.especialidad = ''
            this.medico = ''
            this.beneficiado = ''
            this.isModal = false
          });
      } else {
        this.especialidad = ''
        this.medico = ''
        this.beneficiado = ''
        this.$swal({
          // position: 'top-end',
          title: 'Infomación',
          text: `Selecciona una especialidad, un médico y para quien será el pase.`,
          icon: 'warning',
          confirmButtonText: 'Cerrar',
          showCloseButton: false,
          backdrop: false
          // timer: 1500,
        })
      }
    },
    marcarNuevo(nuevoId) {
      this.lastCreatedId = nuevoId
      this.reloadTrigger++ // Esto fuerza la recarga de la tabla
    },
    cerrar() {
      this.especialidad = ''
      this.medico = ''
      this.beneficiado = ''
      this.isModal = false
    },
    getNumCitas() {
      this.$http.get(`membresia/Numerocitas${this.getIdTarjeta}`)
        .then(response => {
          if (response.status === 200) {
            this.estado = response.data[0].Estatus
            this.numerocitas = response.data[0].NumCitas
          }
        })
        .catch(() => {
        })
        .finally(() => {
        });

    },
  },
};
</script>
